import React from "react";
import {Link} from "react-router-dom";
import StarRating from "./star-rating";
import HelperService from "../services/helper-service";
import {AppRoutes} from "../utils/constants";

export default function EventCell({event, link=null, esid=null, linkReplace="EID", callback = null, ...props}) {

    const TrainerCell = function ({trainer, ...props}) {
        return (<Link to={`${AppRoutes.trainers.path}/${trainer.id}`} className="router-link" title={trainer.name + ' ' + trainer.surname}>
            <div className="clickable rounded-circle border-0 hover-cell-effect">
                <div className="rounded-circle bg-cover" style={{backgroundImage: `url(${trainer.photo})`, width: '65px', height: '65px'}}></div>
            </div>
        </Link>);
    }

    const TrainerBadge = function({trainer, subbed}){
        return <>
            {trainer &&
                <div className="position-absolute z-3" style={{top: '-50px', right: '20px'}}>
                    <TrainerCell trainer={trainer} />
                </div>
            }
        </>
    }

    const PricingCell = function({price, capacity=null}){
        let pm, pn = null;

        if (capacity.nonMember!==0 && price.nonMember!==null){
            pn = price.nonMember===0 ? 'FREE' : '$'+price.nonMember;
        }
        if (capacity.member!==0 && price.member!==null){
            pm = price.member===0 ? 'FREE' : '$'+price.member;
        }

        return <>{(pm || pn) && <div className="">
            {pm && <div className="mb-1">Prepaid / Member from: {pm}</div>}
            {pn && <div className="">Pay per event / Walk-in from: {pn}</div>}
        </div>}</>
    }

    const PricingBadge = function({price, capacity=null}){
        let p, t = null;

        if (capacity.nonMember!==0 && price.nonMember!==null){
            p = price.nonMember===0 ? 'FREE' : '$'+price.nonMember;
            t = 'Walk-In';
        }
        if (capacity.member!==0 && price.member!==null){
            p = price.member===0 ? 'FREE' : '$'+price.member;
            t = 'Member';
        }

        return <>{p && t && <div className="position-absolute top-0 m-3 p-2 rounded-2 d-flex bg-white flex-column align-items-center">
            {p}
            <span className="text-secondary fs-9 text-uppercase">{t}</span>
        </div>}</>
    }

    const PopupBadge = function({popup}){
        //typeLabel.text = classDetail.event?.isSpecial == true ? "POP-UP | SPECIAL EVENT" : "POP-UP | SUB"
        return <>{popup && <div className="position-absolute top-0 end-0 m-3 p-2 rounded-2 d-flex bg-white flex-column align-items-center fs-8 text-uppercase">Pop-Up | Special event</div>}</>
    }

    const RatingBadge = function ({rating}) {
        return <>{rating > 0 && <div className="position-absolute bottom-0 p-2 m-2"><StarRating rating={event.course.rating} count={event.course.ratingsCount} /></div>}</>
    }
    const EventCellCard = function () {
        return <div className="card mb-4 rounded-3 overflow-hidden hover-cell-effect position-relative" onClick={callback ? () => callback(event) : undefined}>
            <div className="position-relative">
                <img alt='' src={event?.course?.cover} className="img-fit w-100" style={{height: "200px", animation: "fadeIn 0.5s"}}/>
                <div className="position-absolute bottom-0 p-2 bg-dark-gradient" style={{height: "50px"}}></div>
                <PricingBadge price={event?.events[0]?.price} capacity={event?.events[0]?.capacity} />
                <RatingBadge rating={event?.course?.rating} />
                <PopupBadge popup={event?.events[0]?.special} />
                {link && event?.events[0]?.id && <Link className="text-decoration-none stretched-link" to={link.replace(linkReplace, event?.events[0]?.id)+(esid ? '?esid='+esid : '')}></Link>}
            </div>
            <div className="card-body position-relative">
                <TrainerBadge trainer={event?.trainer} subbed={event?.events[0]?.subbed} />
                <h6>{event?.course?.name}</h6>
                <div className="text-secondary fs-7 mb-1">{HelperService.getNiceDateString(event?.events[0]?.datetime, event?.events[0]?.timezone) } {HelperService.getEventOffsetString(event?.events[0]?.datetime, event?.events[0]?.timezone)}</div>
                <div className="text-secondary fs-7"><span className="mdi mdi-map-marker-outline"></span> {event?.place?.name}{HelperService.getDistance(event?.place?.location) ? `, (${HelperService.getDistance(event?.place?.location)} mi)`: ''}</div>
                {event?.place?.location && <div className="text-secondary fs-7">{event.place.location.city && event.place.location.state ? `${event.place.location.city}, ${event.place.location.state}` : event.place.location.address }</div>}
            </div>
        </div>
    }

    return <EventCellCard />;
}
